/* eslint-disable @typescript-eslint/no-empty-interface */
import React from 'react';
import styles from './Desktop.module.css';
import { CandidateResumeViewRendererProps } from '../../types';
import DocHTMLViewer from '../../components/DocHTMLViewer';

function Desktop(props: CandidateResumeViewRendererProps) {
  const { resumeDetails, handleResumeUpload, loading } = props;
  return (
    <div className={styles.root}>
      <DocHTMLViewer
        resumeDetails={resumeDetails}
        handleUpload={handleResumeUpload}
        loading={loading}
      />
    </div>
  );
}

export default Desktop;
